/*eslint-disable*/
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useUserContext from "../../hooks/useUserContext";
import getAppById from "./requests/getAppById";
import "./stepper.css";
import EditApplicationModal from "./EditApplicantModal";
import getAppNotifications from "./requests/getAppNotifications";
import updateApplication from "./updateApplication";
import notify from "../../services/toast";
import Logo from "../../assets/NonProfitmed.png";
import SULogo from "../../assets/StartUp.png";
import Modal from "../../components/modal/Modal";
import ButtonPrimary from "../../components/button/ButtonSecondary";
import SelectInput from "../../components/select_input/SelectInput";
import { format } from "date-fns";
import ApplicationFile from "./ApplicationFile";
import config from "../../config";
import getAppsByUserId from "./requests/getAppsByUserId";
import Overview from "../../components/scholarship_tabs/Overview";
import ScorecardGive from "../../components/scholarship_tabs/ScorecardGive";
import ScorecardBoost from "../../components/scholarship_tabs/ScorecardBoost";

function classNames(...classes) {
	return classes.filter(Boolean).join(" ");
}

function ApplicantProfile({ }) {
	const [notification, setNotification] = useState("");
	const [showApplicantModal, setShowApplicantModal] = useState(false);
	const [showUploadFile, setShowUploadFile] = useState(false);
	const { userState } = useUserContext();
	const [appApprovedModal, setAppApprovedModal] = useState(false);
	const [appDeniedModal, setAppDeniedModal] = useState(false);
	const [denyReasonModal, setDenyReasonModal] = useState(false);
	const [application, setApplication] = React.useState({});
	const [apps, setApps] = useState("");
	const app = application;
	const params = useParams();
	const navigate = useNavigate();
	const [idFile, setIdFile] = useState("");
	const [isContacted, setIsContacted] = useState(false);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [scoreMemAwarded, setScoreMemAwarded] = useState();
	const [awardedMember, setAwardedMember] = useState();
	const [showMissionTooltip, setShowMissionTooltip] = useState(false);
	const [showFitTooltip, setShowFitTooltip] = useState(false);
	const [showImpactTooltip, setShowImpactTooltip] = useState(false);
	const [showLocationUsageTooltip, setShowLocationUsageTooltip] = useState(false);
	const [showChallengeTooltip, setShowChallengeTooltip] = useState(false);
	const [showFundingTooltip, setShowFundingTooltip] = useState(false);
	const [showEventsTooltip, setShowEventsTooltip] = useState(false);
	const [showVolunteerTooltip, setShowVolunteerTooltip] = useState(false);
	const [showOverallImpactTooltip, setShowOverallImpactTooltip] = useState(false);
	const [showBusinessPlanTooltip, setShowBusinessPlanTooltip] = useState(false);
	const [showBusinessVideoTooltip, setShowBusinessVideoTooltip] = useState(false);
	const [showFundingStrategyTooltip, setShowFundingStrategyTooltip] = useState(false);
	const [showBreakevenPointTooltip, setShowBreakevenPointTooltip] = useState(false);
	const [showPlanHireTooltip, setShowPlanHireTooltip] = useState(false);
	const [showMembersAwardedTooltip, setShowMembersAwardedTooltip] = useState(false);

	const [tabs, setTabs] = useState([
		{ name: "Overview" },
		{ name: "Scorecard" },
		{ name: "Application" },
	]);

	const [tabYears, setTabYears] = useState([
		{ name: "2023" },
		{ name: "2024" },
	]);

	const [selectedTab, setSelectedTab] = useState("Overview");
	const initialState = apps && apps[0].createdAt;

	const [selectedTabYear, setSelectedTabYear] = useState(initialState);

	// const [selectedTabYear, setSelectedTabYear] = useState(apps && apps.length > 0 ? apps[0].createdAt : null);

	const changeTab = (year) => {
		setSelectedTab(year);
	};

	// Get years for applications
	const tabYear = [...new Set(apps ? apps.map((app) => app.createdAt) : null)];
	const filteredApplication = apps
		? apps.filter((app) => app.createdAt === selectedTabYear)
		: null;
	const selectedApp = filteredApplication ? filteredApplication[0] : null;

	const createdAt = selectedApp?.createdAt ? selectedApp?.createdAt : null;

	const onboardingDate = selectedApp?.onboardingDate ? selectedApp?.onboardingDate : null;
	var submissionDate = new Date(onboardingDate);
	function addYears(date, years) {
		date.setFullYear(date.getFullYear() + years);
		return date;
	}

	var newDate = addYears(submissionDate, 1);

	const orgAmountOPTIONS = [
		{ value: 0, label: "0" },
		{ value: 1, label: "1" },
		{ value: 2, label: "2" },
		{ value: 3, label: "3" },
		{ value: 4, label: "4" },
		{ value: 5, label: "5" },
	];

	const scorecardOPTIONS = [
		{ value: 0, label: "0" },
		{ value: 1, label: "1" },
		{ value: 2, label: "2" },
		{ value: 3, label: "3" },
	];
	const statusOPTIONS = [
		{ value: "rejected", label: "Rejected" },
		{ value: "approved", label: "Approved" },
	];

	const denyReasons = [
		{ value: "Previous Member", label: "Applicant is a previous COhatch member" },
		{ value: "Current Member", label: "Applicant is a current COhatch member" },
		{ value: "Poor Fit", label: "Applicant was a Poor Fit" },
		{ value: "Only wants meeting room hours", label: "Only wants meeting room hours" },
	];

	const [amount, setAmount] = React.useState("");

	// PAYLOAD
	const handleSaveFile = (payload) => {
		const newPayload = {
			...payload,
			idNumber: {
				idOption: "Yes",
				idFile, // Add the file data here
				idReason: null,
			},
		};
		handleSubmit(newPayload); // Submit the updated payload
		setShowUploadFile(false);
	};

	const handleChange = (key, value) => {
		console.log(key, value);
		setPayload({
			...payload,
			[key]: value,
		});
	};

	const handleUpdate = (key, value) => {
		// Update the payload immediately
		const updatedPayload = {
			...payload,
			[key]: value,
		};

		// Automatically handle modal logic based on appStatus
		if (key === "appStatus") {
			if (value === "approved") {
				setAppApprovedModal(true);
				setAppDeniedModal(false);
				setDenyReasonModal(false);
			} else if (value === "rejected") {
				setAppDeniedModal(true);
				setAppApprovedModal(false);
				// Deny reason modal will show after clicking "Deny"
			} else {
				// Pending or other statuses
				setAppApprovedModal(false);
				setAppDeniedModal(false);
				setDenyReasonModal(false);
			}
		}

		setPayload(updatedPayload);
	};

	// Updating Application
	const [payload, setPayload] = React.useState({
		// Personal Info
		firstName: selectedApp?.firstName,
		lastName: selectedApp?.lastName,
		email: selectedApp?.email,
		phoneNumber: selectedApp?.phoneNumber,

		// Application Status
		appStatus: selectedApp?.appStatus,
		denyReason: selectedApp?.denyReason,
		officeRnd: selectedApp?.officeRnd,
		annualAward: selectedApp?.annualAward,
		notes: selectedApp?.notes,

		// Scoring
		scoreMission: selectedApp?.scoreMission,
		scoreImpact: selectedApp?.scoreImpact,
		scoreFunding: selectedApp?.scoreFunding,
		scoreBreakevenPoint: selectedApp?.scoreBreakevenPoint,
		scoreVolunteers: selectedApp?.scoreVolunteers,
		scoreEvents: selectedApp?.scoreEvents,
		scoreChallenges: selectedApp?.scoreChallenges,
		scoreFit: selectedApp?.scoreFit,
		scorePlanHire: selectedApp?.scorePlanHire,
		scoreBusinessVideo: selectedApp?.scoreBusinessVideo,
		scoreBusinessPlan: selectedApp?.scoreBusinessPlan,
		scoreLocationUsage: selectedApp?.scoreLocationUsage,
		scoreOverallAppImpact: selectedApp?.scoreOverallAppImpact,
		scoreMemAwarded: selectedApp?.scoreMemAwarded,

		// Other Info
		awardedMember: selectedApp?.awardedMember,
		market: selectedApp?.market,
		coLocation: selectedApp?.coLocation,
		status501: selectedApp?.status501,
		dateFounded: selectedApp?.dateFounded,
		idNumber: selectedApp?.idNumber,
		applicantContacted: selectedApp?.applicantContacted,
		onboardingDate: selectedApp?.onboardingDate,
	});

	const handleApproveUpdate = () => {
		handleSubmit(payload);
		setAppApprovedModal(false);
	};

	const handleDenyUpdate = () => {
		setAppDeniedModal(false);
		setDenyReasonModal(true);
		//add confetti
	};
	const handleDenyPayload = () => {
		if (!payload.denyReason) {
			notify("Please select a reason for rejection.", "error");
			return;
		}

		handleSubmit(payload); // Submit updated payload
		setDenyReasonModal(false);
		setAppDeniedModal(false);
	};

	const handleGoBack = () => {
		setAppApprovedModal(false);
		setAppDeniedModal(false);
	};
	const handleAnnualAward = (evt) => {
		const amount = evt.value * 2388;
		const members = evt.value;
		setAmount(amount);
		setScoreMemAwarded(members);
		setAwardedMember(members);
		handleChange("annualAward", amount);
	};

	const handleClick = () => {
		// Toggle the state when the button is clicked
		setContacted({
			...contacted,
			applicantContacted: "Yes",
		});
		setIsModalOpen(true);
	};

	const handleConfirm = () => {
		// Toggle the state and close the modal when confirmed
		setIsContacted(!isContacted);
		setPayload({
			...payload,
			applicantContacted: "Yes",
		});
		handleSubmit(payload);
		setIsModalOpen(false);
	};

	const handleCancel = () => {
		// Close the modal when canceled
		setIsContacted(!isContacted);
		setIsModalOpen(false);
	};

	const [contacted, setContacted] = useState({
		idNumber: {
			idFile,
		},
		applicantContacted: application.applicantContacted,
	});

	const fetchApplication = async () => {
		try {
			const response = await getAppById(
				userState.accessToken,
				params.applicationId
			);
			if (response.status === "success") {
				console.log(response.data);
				setApplication(response.data);
				fetchApplicationByUserId(userState.accessToken, response.data.userId);
			} else {
				console.log("error");
			}
		} catch (error) { }
	};

	const fetchApplicationByUserId = async (accessToken, userId) => {
		try {
			const response = await getAppsByUserId(accessToken, userId);
			if (response.status === "success") {
				setApps(response.data);
			} else {
			}
		} catch (error) { }
	};

	const fetchNotifications = async () => {
		try {
			const response = await getAppNotifications(
				userState.accessToken,
				params.applicationId
			);

			if (response.status === "success") {
				const { data } = response;

				setNotification(data);
			} else {
			}
		} catch (error) { }
	};

	const handleReload = async () => {
		await fetchApplication();
	};

	const handleIdFileUpload = (result) => {
		setIdFile({
			idFile: result,
		});
		console.log("Updated Payload:", payload);
		//console.log(idFile, "idfile");
	};
	const [loader, setLoader] = useState(false);
	const handleDocumentUpload = async (data) => {
		// console.log(data.target.files[0], "data");
		try {
			setLoader(true);
			const file = data.target.files[0];
			const folder = "501c3_photos";
			const formData = new FormData();
			formData.append("width", 0);
			formData.append("height", 0);
			formData.append("folder", folder);
			formData.append("file", file);
			formData.append("name", file.name);
			const BASE_API_URL = config["API_BASE_ENDPOINT"];
			const response = await fetch(`${BASE_API_URL}/admin/uploads/files`, {
				method: "POST",
				body: formData,
				headers: {
					Authorization: `Bearer ${userState.accessToken}`,
				},
			});
			if (response.ok) {
				const jsonResponse = await response.json();
				handleIdFileUpload(jsonResponse.data);
			} else {
				notify(
					"An error occurred while uploading file. Please check your file size. If this error persists please contact support@cohatchplus.com.",
					"error"
				);
				return;
			}
		} catch (error) {
			console.log(error, "error");
			// console.log("Something went wrong. Please try again later.", "error");
		} finally {
			setLoader(false);
			console.log("done");
		}
	};
	const handleSubmit = async (payload) => {
		try {
			const response = await updateApplication(
				userState.accessToken,
				payload,
				selectedApp._id
			);

			if (response.status === "success") {
				notify("Application was successfully updated.", "info");
				handleReload();
				// Update apps state
				setApps((prevApps) =>
					prevApps.map((app) =>
						app._id === selectedApp._id
							? { ...app, ...payload } // Merge updated fields
							: app
					)
				);
			} else {
				notify(response.message, "error");
			}
		} catch (error) {
			console.log(error);
			notify("Something went wrong. Please try again later.", "error");
		}
	};

	React.useEffect(() => {
		setPayload({
			...payload,
			scoreMemAwarded: scoreMemAwarded,
		});
	}, [scoreMemAwarded]);

	React.useEffect(() => {
		setPayload({
			...payload,
			awardedMember: awardedMember,
		});
	}, [awardedMember]);

	React.useEffect(() => {
		setPayload({
			...payload,
			scoreMemAwarded: scoreMemAwarded,
		});
	}, [scoreMemAwarded]);
	React.useEffect(() => {
		setPayload({
			...payload,
			awardedMember: awardedMember,
		});
	}, [awardedMember]);

	useEffect(() => {
		fetchApplication();
		fetchNotifications();
	}, []);

	useEffect(() => {
		if (!apps?.length) return;
		setSelectedTabYear(apps[0].createdAt);
	}, [apps]);


	return (
		<>
			{appApprovedModal && (
				<Modal>
					<div className="fixed z-10 inset-0 overflow-y-auto">
						<div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
							{/* <!-- This element is to trick the browser into centering the modal contents. --> */}
							<span
								className="hidden sm:inline-block sm:align-middle sm:h-screen"
								aria-hidden="true"
							>
								&#8203;
							</span>
							<div className="relative inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6 space-y-4">
								<div className="w-full flex justify-between items-center">
									<h1>
										Are you sure you would like to approve this application?
										Approving this application will notify the applicant that
										they have been rewarded a scholarship.
									</h1>
									<ButtonPrimary
										size="md"
										text="Approve"
										action={handleApproveUpdate}
									/>
									<button
										className="ml-3 w-full inline-flex items-center justify-center gap-2 px-2.5 py-1.5 border border-transparent text-md font-medium rounded shadow-sm text-white bg-blue-900 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-400 transition ease-linear duration-500"
										size="md"
										onClick={handleGoBack}
									>
										Go Back
									</button>
								</div>
							</div>
						</div>
					</div>
				</Modal>
			)}
			{appDeniedModal && (
				<Modal>
					<div className="fixed z-10 inset-0 overflow-y-auto">
						<div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
							{/* <!-- This element is to trick the browser into centering the modal contents. --> */}
							<span
								className="hidden sm:inline-block sm:align-middle sm:h-screen"
								aria-hidden="true"
							>
								&#8203;
							</span>
							<div className="relative inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6 space-y-4">
								<div className="w-full flex justify-between items-center ">
									<h1 className="m-10">
										Are you sure you would like to reject this application?
										Rejecting this application will send an email to the
										applicant informing them that they have not been chosen to
										receive a scholarship.
									</h1>
									<button
										className="w-full cursor-pointer relative rounded shadow-sm px-2.5 py-2 text-white bg-red-700 hover:bg-primary-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-400 transition ease-linear duration-500"
										size="md"
										onClick={handleDenyUpdate}
									>
										Reject
									</button>
									<button
										className="ml-3 w-full inline-flex items-center justify-center gap-2 px-2.5 py-1.5 border border-transparent text-md font-medium rounded shadow-sm text-white bg-blue-900 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-400 transition ease-linear duration-500"
										size="md"
										onClick={handleGoBack}
									>
										Go Back
									</button>
								</div>
							</div>
						</div>
					</div>
				</Modal>
			)}
			{denyReasonModal && (
				<Modal>
					<div className="fixed z-10 inset-0 overflow-y-auto">
						<div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
							<span
								className="hidden sm:inline-block sm:align-middle sm:h-screen"
								aria-hidden="true"
							>
								&#8203;
							</span>
							<div className="relative inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6 space-y-4">
								<h1 className="text-lg font-medium mb-4">
									Please select the reason you are rejecting this application.
								</h1>
								<SelectInput
									className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary-400 focus:border-primary-400 sm:text-md capitalize"
									placeholder="Select Reason"
									options={denyReasons}
									setSelectedValue={(evt) => handleUpdate("denyReason", evt.value)}
								/>
								{payload.denyReason && (
									<button
										className="w-full mt-4 inline-flex items-center justify-center gap-2 px-2.5 py-1.5 border border-transparent text-md font-medium rounded shadow-sm text-white bg-blue-900 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-400 transition ease-linear duration-500"
										onClick={handleDenyPayload}
									>
										Submit
									</button>
								)}
							</div>
						</div>
					</div>
				</Modal>
			)}

			{/* Header Section */}

			<div className="overflow-hidden rounded-lg bg-white shadow">
				<div className="bg-white p-6">
					<div className="sm:flex sm:items-center sm:justify-between">
						<div className="sm:flex sm:space-x-5">
							<div className="flex-shrink-0">
								{selectedApp?.logoImage?.small?.url ? (
									<img
										className="mx-auto h-20 w-20 rounded-full"
										src={selectedApp?.logoImage.small.url}
										alt=""
									/>
								) : selectedApp?.logoImage?.logoImage?.url ? (
									<img
										className="mx-auto h-20 w-20 rounded-full"
										src={selectedApp?.logoImage.logoImage.url}
										alt=""
									/>
								) : (
									<img
										className="mx-auto h-20 w-20 rounded-full"
										src={selectedApp ? Logo : SULogo}
										alt=""
									/>
								)}
							</div>
							<div className="mt-4 text-center sm:mt-0 sm:pt-1 sm:text-left">
								<h1 className="text-xl font-bold text-gray-900 sm:text-2xl">
									{selectedApp?.firstName} {selectedApp?.lastName}
								</h1>
								{/* Terms Accepted Status */}
								{selectedApp?.termsAccepted ? (
									<div className="mt-2 inline-flex justify-center rounded-md bg-primary-500 px-3 py-1 text-sm font-semibold text-white">
										Terms Accepted
									</div>
								) : (
									<div className="mt-2 inline-flex justify-center rounded-md bg-danger-500 px-3 py-1 text-sm font-semibold text-white">
										Terms Not Accepted
									</div>
								)}
							</div>
						</div>
						<div className="mt-5 flex justify-center sm:mt-0">
							{selectedApp?.appStatus === "pending" ? (
								<div className="mt-3 inline-flex justify-center rounded-md bg-gray-400/80 px-3 py-2 text-sm font-semibold ">
									<span className="font-black">Pending</span>
								</div>
							) : selectedApp?.appStatus === "rejected" ? (
								<div className="mt-3 inline-flex justify-center rounded-md bg-red-600/80 px-3 py-2 text-sm font-semibold ">
									Rejected
								</div>
							) : selectedApp?.appStatus === "approved" ? (
								<div className="mt-3 inline-flex justify-center rounded-md bg-green-400/80 px-3 py-2 text-sm font-semibold ">
									Active
								</div>
							) : null}
						</div>
					</div>
				</div>


				{/* Tabs aligned in a grid like the new example */}
				<div className="grid grid-cols-1 divide-y divide-gray-200 border-t border-gray-200 bg-gray-50 sm:grid-cols-3 sm:divide-x sm:divide-y-0">
					{tabs.map((tab, tabIdx) => (
						<div
							key={tab.name}
							onClick={() => setSelectedTab(tab.name)}
							className={`px-6 py-5 text-center text-sm font-medium cursor-pointer ${tab.name === selectedTab ? "bg-success-800 text-white" : "text-gray-600"} hover:bg-gray-200`}
						>
							<span>{tab.name}</span>
						</div>
					))}
				</div>
			</div>

			{/* Application Year Nav */}
			<section className="mt-4 flex flex-col items-center bg-gray-50 py-6 rounded-lg shadow-lg">
				{/* Tabs */}
				<div className="sm:hidden w-full">
					<label htmlFor="tabs" className="sr-only">
						Select a tab
					</label>
					<select
						id="tabs"
						name="tabs"
						className="mt-4 block w-full max-w-xs rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 text-base focus:border-primary-500 focus:outline-none focus:ring focus:ring-primary-500 sm:text-sm transition duration-200 ease-in-out shadow-md hover:shadow-lg"
						onChange={(e) => changeTab(e.target.value)}
					>
						{tabYear.map((year) => (
							<option key={year} value={year}>
								{format(new Date(year), "yyyy")}
							</option>
						))}
					</select>
				</div>

				<div className="hidden sm:block w-full">
					<div className="border-b">
						<nav className="flex justify-center" aria-label="Tabs">
							{tabYear.map((year) => (
								<div
									key={year}
									onClick={() => setSelectedTabYear(year)}
									className={classNames(
										selectedTabYear === year
											? "bg-primary-600 text-white border-primary-600" // Change to primary-600
											: "border-transparent text-gray-600 hover:bg-primary-100 hover:text-primary-600 hover:border-primary-300", // Change to primary colors
										"whitespace-nowrap py-3 px-6 border-b-2 font-medium text-sm cursor-pointer transition duration-300 ease-in-out rounded-lg"
									)}
								>
									{format(new Date(year), "yyyy")}
								</div>
							))}
						</nav>
					</div>
				</div>
			</section>

			{/*Page Nav */}

			<div className="  grid grid-cols-6 gap-4 mb-16">
				{selectedTab === "Overview" && (
					<Overview
						selectedApp={selectedApp}
						setShowUploadFile={setShowUploadFile}
						showUploadFile={showUploadFile}
						handleDocumentUpload={handleDocumentUpload}
						handleSaveFile={handleSaveFile}
						idFile={idFile}
						loader={loader}
					/>
				)}

				{/* SCORECARD */}
				{selectedTab === "Scorecard" && (
					<div className="mt-10 col-span-4 w-4/3">
						<div className="">
							<h1 className="mb-6 font-bold text-2xl text-gray-800">Scorecard</h1>
							{selectedApp?.type === "give" && (
								<>
									<ScorecardGive
										selectedApp={selectedApp}
										showBusinessVideoTooltip={showBusinessVideoTooltip}
										setShowBusinessVideoTooltip={setShowBusinessVideoTooltip}
										showMissionTooltip={showMissionTooltip}
										setShowMissionTooltip={setShowMissionTooltip}
										showImpactTooltip={showImpactTooltip}
										setShowImpactTooltip={setShowImpactTooltip}
										showLocationUsageTooltip={showLocationUsageTooltip}
										setShowLocationUsageTooltip={setShowLocationUsageTooltip}
										showChallengeTooltip={showChallengeTooltip}
										setShowChallengeTooltip={setShowChallengeTooltip}
										showFundingTooltip={showFundingTooltip}
										setShowFundingTooltip={setShowFundingTooltip}
										showEventsTooltip={showEventsTooltip}
										setShowEventsTooltip={setShowEventsTooltip}
										showVolunteerTooltip={showVolunteerTooltip}
										setShowVolunteerTooltip={setShowVolunteerTooltip}
										showOverallImpactTooltip={showOverallImpactTooltip}
										setShowOverallImpactTooltip={setShowOverallImpactTooltip}
										showMembersAwardedTooltip={showMembersAwardedTooltip}
										setShowMembersAwardedTooltip={setShowMembersAwardedTooltip}
										handleChange={handleChange}
										scorecardOPTIONS={scorecardOPTIONS}
										orgAmountOPTIONS={orgAmountOPTIONS}
										handleAnnualAward={handleAnnualAward}
										amount={amount}
									/>
								</>
							)}
							{selectedApp?.type === "boost" && (
								<>
									<ScorecardBoost
										selectedApp={selectedApp}
										showBusinessVideoTooltip={showBusinessVideoTooltip}
										setShowBusinessVideoTooltip={setShowBusinessVideoTooltip}
										showBusinessPlanTooltip={showBusinessPlanTooltip}
										setShowBusinessPlanTooltip={setShowBusinessPlanTooltip}
										showLocationUsageTooltip={showLocationUsageTooltip}
										setShowLocationUsageTooltip={setShowLocationUsageTooltip}
										showBreakevenPointTooltip={showBreakevenPointTooltip}
										setShowBreakevenPointTooltip={setShowBreakevenPointTooltip}
										showChallengeTooltip={showChallengeTooltip}
										setShowChallengeTooltip={setShowChallengeTooltip}
										showPlanHireTooltip={showPlanHireTooltip}
										setShowPlanHireTooltip={setShowPlanHireTooltip}
										showOverallImpactTooltip={showOverallImpactTooltip}
										setShowOverallImpactTooltip={setShowOverallImpactTooltip}
										showMembersAwardedTooltip={showMembersAwardedTooltip}
										setShowMembersAwardedTooltip={setShowMembersAwardedTooltip}
										handleChange={handleChange}
										scorecardOPTIONS={scorecardOPTIONS}
										orgAmountOPTIONS={orgAmountOPTIONS}
										handleAnnualAward={handleAnnualAward}
										amount={amount}
									/>
								</>
							)}
						</div>
						<div className="w-full relative bg-white rounded-lg p-4 shadow-sm mt-10">
							<h1 className="mb-8 font-bold text-xl">Application Status</h1>

							{userState.role[0] === "MASTER_APPROVAL" ? (
								<div className="w-full space-y-3 sm:flex sm:justify-between sm:gap-3 sm:space-y-0">
									<div className="w-full">
										<label className="block font-medium text-gray-800 mb-2">
											Status
										</label>
										<div className="mt-1">
											{selectedApp?.appStatus === "pending" ? (
												<SelectInput
													className="capitalize appearance-none block w-full px-4 py-3 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary-400 focus:border-primary-400 sm:text-md"
													placeholder={String(selectedApp?.appStatus).toUpperCase()}
													options={statusOPTIONS}
													setSelectedValue={(evt) =>
														handleUpdate("appStatus", evt.value)
													}
												/>
											) : (
												<div className="flex-shrink-0 text-sm text-gray-600 px-4 py-3 border border-gray-600 rounded-md">
													{String(selectedApp?.appStatus).toUpperCase()}
												</div>
											)}
										</div>
									</div>
								</div>
							) : (
								<div className="w-full space-y-3 sm:flex sm:justify-between sm:gap-3 sm:space-y-0">
									<div className="w-full">
										<label className="block font-medium text-gray-800 mb-2">
											Status
										</label>
										<div className="mt-1">
											<div className="flex-shrink-0 text-sm text-gray-600 px-4 py-3 border border-gray-600 rounded-md">
												{String(selectedApp?.appStatus).toUpperCase()}
											</div>
										</div>
									</div>
								</div>
							)}

							{/* Show Deny Reason inline if rejected */}
							{selectedApp?.appStatus === "rejected" && (
								<div className="w-full mt-4">
									<label className="block font-medium text-gray-800 mb-2">
										Deny Reason
									</label>

									{selectedApp?.appStatus === "pending" ? (
										<SelectInput
											className="appearance-none block w-full px-4 py-3 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary-400 focus:border-primary-400 sm:text-md capitalize"
											placeholder={selectedApp?.denyReason || "Select reason"}
											options={denyReasons}
											setSelectedValue={(evt) =>
												handleUpdate("denyReason", evt.value)
											}
										/>
									) : (
										<div className="mt-1">
											<div className="flex-shrink-0 text-sm text-gray-600 px-4 py-3 border border-gray-300 rounded-md">
												{selectedApp?.denyReason?.toUpperCase() || "No reason"}
											</div>
										</div>
									)}
								</div>

							)}

							{/* Other statuses (like OfficeRnD, 501C3) */}
							<div className="w-full space-y-3 sm:flex sm:justify-between sm:gap-3 sm:space-y-0 mt-4">
								{selectedApp?.type === "give" && (
									<div className="w-full">
										<label className="block font-medium text-gray-800 mb-2">
											501C3 Approved
										</label>
										<SelectInput
											className="appearance-none block w-full px-4 py-3 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary-400 focus:border-primary-400 sm:text-md"
											options={statusOPTIONS}
											placeholder={String(selectedApp?.status501).toUpperCase()}
											setSelectedValue={(evt) => handleUpdate("status501", evt.value)}
										/>
									</div>
								)}

								<div className="w-full">
									<label className="block font-medium text-gray-800 mb-2">
										OfficeRnD Status
									</label>
									<SelectInput
										className="appearance-none block w-full px-4 py-3 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary-400 focus:border-primary-400 sm:text-md"
										options={statusOPTIONS}
										placeholder={String(selectedApp?.officeRnd).toUpperCase()}
										setSelectedValue={(evt) => handleUpdate("officeRnd", evt.value)}
									/>
								</div>
							</div>
						</div>

						<div className="w-full flex justify-end mt-6">
							<button
								className="inline-flex items-center justify-center rounded-lg border border-transparent bg-primary-600 py-3 px-6 text-sm font-semibold text-white shadow-sm transition duration-150 ease-in-out hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-600 focus:ring-offset-2"
								type="button"
								onClick={() => {
									handleUpdate(payload);
								}}
							>
								Save Changes
							</button>
						</div>
					</div>
				)}

				{selectedTab === "Application" && (
					<div className="mt-10 col-span-4 ">
						{selectedApp && (
							<ApplicationFile applicationId={selectedApp._id} />
						)}
					</div>
				)}

				{/* Info Overview Section */}
				<div className="mt-2 col-span-2">
					<div className="rounded-md p-3 bg-white shadow-lg">
						{selectedApp?.type === "boost" &&
							selectedApp?.jobRole != null ? (
							<div className="mb-3">
								<h1 className="font-bold ">Job Role</h1>
								<p className="text-gray-600">{selectedApp?.jobRole}</p>
							</div>
						) : null}
						<div className="mb-3">
							<h1 className="font-bold">Location & Market</h1>
							<p className="capitalize text-gray-600">
								{selectedApp?.coLocation} | {selectedApp?.market}
							</p>
						</div>
						<div className="mb-3">
							<h1 className="font-bold ">Email</h1>
							<p className="truncate hover:text-clip text-gray-600">
								{selectedApp?.email}
							</p>
						</div>
						<div className="mb-3">
							<h1 className="font-bold ">Phone Number</h1>
							<p className="text-gray-600">{selectedApp?.phoneNumber}</p>
						</div>
						<div className="mb-3">
							<h1 className="font-bold ">Website</h1>
							<p className="text-gray-600">{selectedApp?.website}</p>
						</div>
						{selectedApp?.type === "boost" &&
							selectedApp?.dateFounded != null ? (
							<div className="mb-3">
								<h1 className="font-bold ">Date Founded</h1>
								<p className="text-gray-600">{selectedApp?.dateFounded}</p>
							</div>
						) : null}

						<div className="mb-3">
							<h1 className="font-bold ">Submission Date</h1>
							<p className="text-gray-600">
								<time>{format(new Date(createdAt), "MMMM do, yyyy")}</time>
							</p>
						</div>

						{selectedApp?.onboardingDate != null ? (
							<div className="mb-3">
								<h1 className="font-bold">Onboarding Date</h1>
								<time className="text-gray-600">
									{(() => {
										// Create a Date object from the UTC date string
										const date = new Date(selectedApp?.onboardingDate);

										// Get the local time zone offset in minutes
										const timezoneOffset = date.getTimezoneOffset();

										// Set the date to midnight UTC (so it doesn’t adjust)
										const utcDate = new Date(date.getTime() + timezoneOffset * 60000);

										// Return the formatted local date
										return utcDate.toLocaleDateString('en-US', {
											year: 'numeric',
											month: 'long',
											day: 'numeric',
										});
									})()}
								</time>
							</div>
						) : null}

						{selectedApp?.onboardingDate != null ? (
							<div className="mb-3">
								<h1 className="font-bold">Renewal Date</h1>
								<p className="text-gray-600">
									<time>
										{format(new Date(newDate), "MMMM do, yyyy")}
									</time>
								</p>
							</div>
						) : null}

						<div className="mb-3">
							<h1 className="font-bold ">Sponsorship</h1>
							<p className="text-gray-600">
								{selectedApp?.orgSponsored === "no"
									? "Not Sponsored"
									: `Sponsored by: ${selectedApp?.orgSponsored}`}
							</p>
						</div>
						<div className="mb-3">
							<h1 className="font-bold ">Applicant Contacted ?</h1>
							<button
								className={`bg-${isContacted ? "green" : "blue"
									}-500 hover:bg-${isContacted ? "green" : "blue"
									}-700 text-white font-bold py-2 px-4  border-2 rounded focus:outline-none focus:shadow-outline`}
								style={{ color: "black" }} // Set contrasting text color
								onClick={handleClick}
							>
								{selectedApp?.applicantContacted
									? selectedApp?.applicantContacted
									: "No"}
							</button>
						</div>
						{/* <div className="mb-3">
								<h1 className="font-bold">Ban Application</h1>
								<button
									onClick={handleBanApplication}
									className="cursor-pointer relative rounded shadow-sm px-2.5 py-2 text-white bg-red-500"
								>
									{selectedApp?.appBanned ? "Unban" : "Ban"}
								</button>
							</div> */}

						<div className="mb-3">
							<button
								className="cursor-pointer relative rounded shadow-sm px-2.5 py-2 text-white  bg-success-800 "
								size="md"
								onClick={() => setShowApplicantModal(true)}
							>
								Edit Application
							</button>
							{selectedApp && (
								<EditApplicationModal
									open={showApplicantModal}
									onClose={() => setShowApplicantModal(false)}
									app={selectedApp}
									handleSubmit={handleSubmit}
								/>
							)}
						</div>
						{isModalOpen && (
							<Modal>
								<div className="fixed z-10 inset-0 overflow-y-auto">
									<div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
										{/* <!-- This element is to trick the browser into centering the modal contents. --> */}
										<span
											className="hidden sm:inline-block sm:align-middle sm:h-screen"
											aria-hidden="true"
										>
											&#8203;
										</span>
										<div className="relative inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6 space-y-4">
											<div className="w-full flex justify-between items-center">
												<div>
													<p>Are you sure you want to update the status?</p>
													<button
														className="mb-2 ml-3 w-full inline-flex items-center justify-center gap-2 px-2.5 py-1.5 border border-transparent text-md font-medium rounded shadow-sm text-white bg-blue-900 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-400 transition ease-linear duration-500"
														onClick={handleConfirm}
													>
														Yes
													</button>
													<ButtonPrimary
														className="text-gray-700 block px-4 py-2 text-sm"
														text="Cancel"
														action={handleCancel}
													/>
												</div>
											</div>
										</div>
									</div>
								</div>
							</Modal>
						)}
					</div>
				</div>
			</div>
		</>
	);
}

export default ApplicantProfile;
